import React from "react";
import { Input } from "antd";
import styles from "../styles/BusinessInfo.module.css";

export default function BusinessUSP({ answers, onAnswerChange }) {
    const handleInputChange = (e) => {
        onAnswerChange("businessUSP", e.target.value);
    };

    return (
        <div className={styles.slideContent}>
            <h2 className={styles.slideTitle}>
                What makes your business stand out?
            </h2>
            <p className={styles.slideSubtitle}>
                Share your unique selling proposition or what sets you apart
                from competitors
            </p>

            <div className={styles.questionsContainer}>
                <div className={styles.questionGroup}>
                    <div className={styles.textareaField}>
                        <Input.TextArea
                            placeholder="e.g. We create dermatologist-approved skincare products made from clean, plant-based ingredients. Our formulas are designed specifically for sensitive skin, with zero harsh chemicals, no artificial fragrance, and recyclable packaging."
                            value={answers.businessUSP || ""}
                            onChange={handleInputChange}
                            rows={6}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
